'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UsageReportingModal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fixedModal = require('common/components/fixed-modal');

var _fixedModal2 = _interopRequireDefault(_fixedModal);

var _blocks = require('ui/blocks');

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _modalClose2x = require('common/assets/modal-close@2x.png');

var _modalClose2x2 = _interopRequireDefault(_modalClose2x);

require('./modal.scss');

var _info = require('common/images/info.svg');

var _info2 = _interopRequireDefault(_info);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2['default'].Component,
    PropTypes = _react2['default'].PropTypes;

var UsageReportingModal = exports.UsageReportingModal = function (_Component) {
    _inherits(UsageReportingModal, _Component);

    function UsageReportingModal(props) {
        _classCallCheck(this, UsageReportingModal);

        var _this = _possibleConstructorReturn(this, (UsageReportingModal.__proto__ || Object.getPrototypeOf(UsageReportingModal)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);

        _this.state = {
            values: {
                compliance: false,
                usage: false
            }
        };
        return _this;
    }

    _createClass(UsageReportingModal, [{
        key: 'handleChange',
        value: function handleChange(option) {
            var _this2 = this;

            return function (e) {
                _this2.setState(function (previousState) {
                    return _extends({}, previousState, {
                        values: _extends({}, previousState.values, _defineProperty({}, option, !previousState.values[option]))
                    });
                });
            };
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            e.preventDefault();

            this.props.onSubmit(this.state.values);
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            var values = this.state.values;


            return values.compliance || values.usage;
        }
    }, {
        key: 'render',
        value: function render() {
            var _React$createElement, _React$createElement2;

            var _props = this.props,
                allowedOptions = _props.allowedOptions,
                busy = _props.busy,
                isEnabled = _props.isEnabled,
                onClose = _props.onClose,
                rounded = _props.rounded;
            var values = this.state.values;

            var valid = this.isValid();

            var modalStyle = { borderRadius: rounded ? 5 : 0 };
            var usageAllowed = allowedOptions.includes('usage');
            var complianceDisabled = !isEnabled || !allowedOptions.includes('compliance') || busy;
            var usageDisabled = !isEnabled || !usageAllowed || busy;
            var submitDisabled = !isEnabled || !valid;

            var pricingUrl = _hfReactHelper2['default'].urlHelper('info/pricing?contact_sales=1', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);

            return _react2['default'].createElement(
                _fixedModal2['default'],
                { width: 600, modalStyle: modalStyle },
                _react2['default'].createElement(
                    'div',
                    {
                        className: 'team-reporting-modal-close-button',
                        onClick: onClose
                    },
                    _react2['default'].createElement('img', { src: _modalClose2x2['default'] })
                ),
                _react2['default'].createElement(
                    'form',
                    { onSubmit: this.handleSubmit },
                    _react2['default'].createElement(
                        _blocks.Box,
                        { py: 4, px: 3 },
                        _react2['default'].createElement(
                            _blocks.Text,
                            {
                                fontSize: 4,
                                fontWeight: 'semibold',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                mb: 3
                            },
                            'Reporting: Select Report'
                        ),
                        _react2['default'].createElement(
                            _blocks.Box,
                            { p: 3 },
                            _react2['default'].createElement(
                                _blocks.Box,
                                { mb: 4 },
                                _react2['default'].createElement('input', {
                                    type: 'checkbox',
                                    value: 'compliance',
                                    name: 'compliance',
                                    onChange: this.handleChange('compliance'),
                                    checked: values.compliance,
                                    id: 'teams-report-compliance',
                                    disabled: complianceDisabled
                                }),
                                _react2['default'].createElement(
                                    _blocks.Box,
                                    {
                                        is: 'label',
                                        htmlFor: 'teams-report-compliance',
                                        color: complianceDisabled ? 'light-grey' : '',
                                        fontWeight: 'normal',
                                        fontSize: 4
                                    },
                                    'Compliance'
                                ),
                                _react2['default'].createElement(
                                    _blocks.Text,
                                    {
                                        color: complianceDisabled ? 'light-grey' : ''
                                    },
                                    'The compliance report includes your team\'s account status and last login date.'
                                )
                            ),
                            _react2['default'].createElement(
                                _blocks.Box,
                                null,
                                _react2['default'].createElement('input', {
                                    type: 'checkbox',
                                    value: 'usage',
                                    name: 'usage',
                                    checked: values.usage,
                                    onChange: this.handleChange('usage'),
                                    id: 'teams-report-usage',
                                    disabled: usageDisabled
                                }),
                                _react2['default'].createElement(
                                    _blocks.Box,
                                    {
                                        is: 'label',
                                        htmlFor: 'teams-report-usage',
                                        color: usageDisabled ? 'light-grey' : '',
                                        fontWeight: 'normal',
                                        fontSize: 4
                                    },
                                    'Usage'
                                ),
                                _react2['default'].createElement(
                                    _blocks.Text,
                                    { color: usageDisabled ? 'light-grey' : '' },
                                    'The usage report includes templates owned, requests sent over the last 6 months, and signed documents over the last 6 months.'
                                )
                            )
                        ),
                        isEnabled && !usageAllowed && _react2['default'].createElement(
                            _blocks.Box,
                            { my: 2, px: 3 },
                            _react2['default'].createElement(
                                _blocks.Flex,
                                { alignItems: 'center' },
                                _react2['default'].createElement(_blocks.Box, (_React$createElement = {
                                    mr: 2,
                                    is: 'img',
                                    src: _info2['default']
                                }, _defineProperty(_React$createElement, 'mr', 2), _defineProperty(_React$createElement, 'className', 'team-reporting-modal__info-icon'), _React$createElement)),
                                _react2['default'].createElement(
                                    _blocks.Text,
                                    { fontSize: 6 },
                                    'Usage report was generated within the last hour. Please try again later.'
                                )
                            )
                        ),
                        !isEnabled && _react2['default'].createElement(
                            _blocks.Box,
                            { my: 2, px: 3 },
                            _react2['default'].createElement(
                                _blocks.Flex,
                                { alignItems: 'center' },
                                _react2['default'].createElement(_blocks.Box, (_React$createElement2 = {
                                    mr: 2,
                                    is: 'img',
                                    src: _info2['default']
                                }, _defineProperty(_React$createElement2, 'mr', 2), _defineProperty(_React$createElement2, 'className', 'team-reporting-modal__info-icon'), _React$createElement2)),
                                _react2['default'].createElement(
                                    _blocks.Text,
                                    { fontSize: 6 },
                                    'This feature isn\'t available on your current plan.',
                                    _react2['default'].createElement('br', null),
                                    'Please',
                                    ' ',
                                    _react2['default'].createElement(
                                        'a',
                                        { href: pricingUrl },
                                        'contact our Sales team'
                                    ),
                                    ' ',
                                    'for more information about this and other HelloSign Enterprise features.'
                                )
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { p: 3, className: 'team-reporting-modal-bar' },
                        _react2['default'].createElement(
                            _blocks.Flex,
                            { justifyContent: 'end', alignItems: 'center' },
                            _react2['default'].createElement(
                                _blocks.Text,
                                {
                                    color: 'grey',
                                    is: 'a',
                                    fontSize: 6,
                                    px: 2,
                                    onClick: onClose
                                },
                                'Cancel'
                            ),
                            _react2['default'].createElement(_button2['default'], {
                                buttonColor: 'cerulean',
                                buttonText: busy ? 'Submitting...' : 'Submit',
                                disabled: submitDisabled,
                                type: 'submit'
                            })
                        )
                    )
                )
            );
        }
    }]);

    return UsageReportingModal;
}(Component);

UsageReportingModal.defaultProps = {
    allowedOptions: ['compliance', 'usage'],
    rounded: true
};
UsageReportingModal.propTypes = {
    allowedOptions: PropTypes.arrayOf(PropTypes.oneOf(['compliance', 'usage'])),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    rounded: PropTypes.bool,
    successful: PropTypes.bool
};
exports['default'] = UsageReportingModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/team-reporting/modal.jsx
 ** module id = 854
 ** module chunks = 0
 **/